/**************************************************************************************************/
/*   File: /src/app/shared/components/fileuploader/fileuploader.component.ts                      */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Thu Aug 08 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { NGXLogger } from 'ngx-logger';

import {
  Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges
} from '@angular/core';

import * as fromModels from '../../../shared/models';
import * as fromEnums from '../../../shared/enums';

/**
 * The file uploader component
 */
@Component({
  selector: 'nwpl-frnt-fileuploader',
  templateUrl: './fileuploader.component.html',
  styleUrls: ['./fileuploader.component.scss']
})
export class FileUploaderComponent implements OnInit, OnChanges {

  /**
   * Show the delete warning
   */
  @Input() deleteWarningShow: boolean;
  /**
   * The context
   */
  @Input() context: string;

  /**
   * The accepted file array
   */
  @Input() acceptedTypes: Array<string>;

  /**
   * The max number of file
   */
  @Input() maxFileNumber: number;

  /**
   * The current store file count
   */
  @Input() currentFileCount = 0;

  /**
   * The files array
   */
  @Input() files: Array<any> = [];

  /**
   * The text to show
   */
  @Input() text: string;

  /**
   * The text to show
   */
  @Input() textUpload: string;

  /**
   * The text to show
   */
  @Input() confirmText: string;

  /**
   * The upload finished
   */
  @Input() uploadFinished: boolean;

  /**
   * The fileChoosed event emitted
   */
  @Output() fileChoosed: EventEmitter<Array<fromModels.FileModel>> = new EventEmitter<Array<fromModels.FileModel>>();

  /**
   * The event for remove file
   */
  @Output() removedFile: EventEmitter<number> = new EventEmitter<number>();

  /**
   * The event for clear all files
   */
  @Output() clearedFiles: EventEmitter<Event> = new EventEmitter<Event>();

  /**
   * The file over zone
   */
  @Output() fileOverZone: EventEmitter<Event> = new EventEmitter<Event>();

  /**
   * The file leave zone
   */
  @Output() fileLeaveZone: EventEmitter<Event> = new EventEmitter<Event>();

  /**
   * The file leave zone
   */
  @Output() fileDroppedZone: EventEmitter<Event> = new EventEmitter<Event>();

  /**
   * The uploaded files emitter
   */
  @Output() uploadedFiles: EventEmitter<Event> = new EventEmitter<Event>();

  /**
   * The error occurred event emitter
   */
  @Output() errorOccurred: EventEmitter<fromModels.Message> = new EventEmitter<fromModels.Message>();
  /**
   * File removed
   */
  fileJustRemoved = false;
  /**
   * The message for persistency problem
   * @type {fromModels.Message}
   */
  PERSISTENCY_WARNING: fromModels.Message = new fromModels.Message(
    fromEnums.MessageType.WARNING,
    fromEnums.Messages.PERSISTENCY_WARNING,
    fromEnums.MessagePositionEnum.TOP,
    undefined,
    false
  );

  /**
   * The constructor
   * @param logger The logger
   */
  constructor(private logger: NGXLogger) { }

  /**
   * The ng on init hook
   */
  ngOnInit() {
    this.logger.trace('Initialize file uploader component', this.acceptedTypes, this.maxFileNumber, this.currentFileCount, this.files);
  }

  /**
   * The ng on init hook
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.files && changes.files.currentValue) {
      this.logger.trace('Files are', changes.files);
      this.currentFileCount = changes.files.currentValue.length;
    }
  }

  /**
   * On file choosed event
   * @param $event The event
   */
  onFileChoosed($event: Array<fromModels.FileModel>) {
    this.logger.trace('On file choosed inside file uploader');
    this.fileJustRemoved = false;
    this.fileChoosed.emit($event);
  }


  /**
   * The removed file event handler
   * @param  $event the id to remove
   */
  onFileRemoved($event: number) {
    this.logger.trace('On file removed');
    this.fileJustRemoved = true;
    this.removedFile.emit($event);
  }

  /**
   * The cleared file event handler
   * @param  $event the event
   */
  onClearFiles($event: Event) {
    this.logger.trace('Cleared files');
    this.clearedFiles.emit($event);
  }

  /**
   * Drag the file/img above the drag zone.
   * This function will execute untill the file above the drag zone.
   *
   * @param {Event} event
   * @memberof UploadBodyComponent
   */
  onFileOverZone(event: Event) {
    this.logger.trace('Emit file zone over');
    this.fileOverZone.emit(event);
  }

  /**
   * On file leave event handler
   * @param {*} event
   * @memberof UploadBodyComponent
   */
  onFileLeaveZone(event: any) {
    this.logger.trace('Emit file zone leave');
    this.fileLeaveZone.emit(event);
  }

  /**
   * When you release the file/img over the drag zone.
   *
   * @param {Event} event
   * @memberof UploadBodyComponent
   */
  onDropFile($event: Event) {
    this.logger.trace('Emit dropped');
    this.fileDroppedZone.emit($event);
  }

  /**
   * On uploaded files event handler
   * @param  $event Event
   */
  onUploadedFiles($event: Event) {
    this.uploadedFiles.emit($event);
  }

  /**
   * The error occurred event handler
   * @param message The message
   */
  onErrorOccurred(message: fromModels.Message) {
    this.errorOccurred.emit(message);
  }
}